import {setInitialNodeSendNotificationData} from '@ReduxActions'
import {PortModelAlignment} from '@projectstorm/react-diagrams'
import {store} from '../../../../store'
import {NodeTypeEnum} from '../../../../types/NodeTypeEnum'
import {removeNodeAndConnectItsParentAndTarget} from '../../utils/NodeEventUtils'
import {CustomNodeModel} from '../CustomNodeModel'
import {SendWhatsAppPortModel} from './SendWhatsAppPortModel'

// this can be further extended for more complicated node types
export class SendWhatsAppNodeModel extends CustomNodeModel {
  constructor(id?: string) {
    const obj = {
      type: NodeTypeEnum.sendWhatsApp,
      id,
      extras: {
        name: 'Send WhatsApp',
        priority: 4,
        nodeSize: 250,
      },
    }
    if (!id) delete obj.id

    super(obj)

    this.addPort(new SendWhatsAppPortModel(PortModelAlignment.TOP))
    this.addPort(new SendWhatsAppPortModel(PortModelAlignment.BOTTOM))

    store.dispatch(
      setInitialNodeSendNotificationData({
        id: this.getID(),
        type: NodeTypeEnum.sendWhatsApp,
      })
    )
  }

  remove() {
    removeNodeAndConnectItsParentAndTarget(this.getID(), () => super.remove())
  }
}
